import { z } from "zod";

// Auxiliares para conversão de dados do formulário
const optionalDate = z.coerce.date().nullable().optional();

const optionalValor = z.coerce.string().nullable().default(null).transform(x => {
  return x !== null && x !== undefined && x.toString().trim().length > 0 ? Number(x) : null;
});

export const EntradaProdutoSchema = z.object({
  IdEntradaProduto: z.number().optional(),
  Data: optionalDate,
  IdCentroCusto: z.coerce.number().nullable().optional(),
  IdProdutoServico: z.coerce.number().nullable().optional(),
  NroNotaFiscal: z.string().max(250, "Máximo de 250 caracteres").nullable().optional(),
  Quantidade: optionalValor,
  IdFornecedor: z.coerce.number().nullable().optional(),
  IdOrdemCompraProduto: z.coerce.number().nullable().optional(),
  NrNotaFiscal: z.string().max(50, "Máximo de 50 caracteres").nullable().optional(),
  IdSessaoMultipla: z.string().uuid("Formato de UUID inválido").nullable().optional(),
  ValorUnitario: optionalValor,
  ValorTotal: optionalValor,
  Unidade: z.coerce.string().nullable().optional(),

  //Extra
  DataSaida: optionalDate,
});

export type EntradaProdutoForm = z.infer<typeof EntradaProdutoSchema>;

export const EntradaProdutoMultiSchema = EntradaProdutoSchema.extend({
  IdCentroCusto: EntradaProdutoSchema.shape.IdCentroCusto.refine(
    value => value != null && Number.isInteger(value) && value > 0,
    "Selecione o Centro de Custo.",
  ),
});
